import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Logo from "../images/lena-lejskova-tattoo-artist-hodonin-logo.webp";

function Header() {
  const [tattooDropdownOpen, setTattooDropdownOpen] = useState(false);
  const [educationDropdownOpen, setEducationDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const tattooDropdownRef = useRef(null);
  const educationDropdownRef = useRef(null);
  const menuRef = useRef(null);

  const closeMenus = () => {
    setTattooDropdownOpen(false);
    setEducationDropdownOpen(false);
    setMenuOpen(false);
  };

  const toggleTattooDropdown = () => {
    setTattooDropdownOpen((open) => !open);
    setEducationDropdownOpen(false);
  };

  const toggleEducationDropdown = () => {
    setEducationDropdownOpen((open) => !open);
    setTattooDropdownOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (tattooDropdownRef.current && !tattooDropdownRef.current.contains(event.target)) {
        setTattooDropdownOpen(false);
      }

      if (educationDropdownRef.current && !educationDropdownRef.current.contains(event.target)) {
        setEducationDropdownOpen(false);
      }

      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="App-header">
      <div className="navigation">
        <div className="nav-left">
          <Link to="/" onClick={closeMenus}>
            <img src={Logo} alt="lena-lejskova-tattoo-artist-hodonin-logo" className="logo" />
          </Link>
        </div>
        <button
          className="hamburger-menu"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Menu"
        >
          ☰
        </button>
        <div className={`nav-right ${menuOpen ? "open" : ""}`} ref={menuRef}>
          <ol>
            <li>
              <Link to="/" onClick={closeMenus}>Lena</Link>
            </li>
            <li ref={tattooDropdownRef} className="dropdown">
              <button onClick={toggleTattooDropdown} className="dropbtn">Tattoo</button>
              {tattooDropdownOpen && (
                <div className="dropdown-content">
                  <Link to="/tattoo-gallery" onClick={closeMenus}>Tetování</Link>
                  <Link to="/art-gallery" onClick={closeMenus}>Dizajny</Link>
                </div>
              )}
            </li>
            <li>
              <Link to="/merch" onClick={closeMenus}>Merch</Link>
            </li>
            <li>
              <Link to="/paint" onClick={closeMenus}>Obrazy</Link>
            </li>
            <li ref={educationDropdownRef} className="dropdown">
              <button onClick={toggleEducationDropdown} className="dropbtn">Vzdělání</button>
              {educationDropdownOpen && (
                <div className="dropdown-content education-dropdown-content">
                  <Link to="/masterclass-education" onClick={closeMenus}>Masterclass</Link>
                  <Link to="/course-education" onClick={closeMenus}>Akreditované kurzy</Link>
                </div>
              )}
            </li>
            <li>
              <Link to="/contact" onClick={closeMenus}>Kontakt</Link>
            </li>
          </ol>
        </div>
      </div>
    </header>
  );
}

export default Header;
